import { i18n, I18nKey } from 'i18n'
import { makeAutoObservable } from 'mobx'
import { opt } from 'store/opt'

export class FilterStore {
  private readonly _title: I18nKey
  readonly type: string
  private _value: string[] = []
  private _open: boolean = false
  private _expand: boolean = false
  private _search: string = ''
  private readonly _trigger?: () => void

  constructor(title: I18nKey, type: string, trigger?: () => void) {
    makeAutoObservable(this)
    this._title = title
    this.type = type
    this._trigger = trigger
  }

  get title(): string {
    if (opt.foo && this._title === 'demo.Brand') {
      return i18n('demo.Country')
    }
    return i18n(this._title)
  }

  get value(): string[] {
    return this._value
  }

  set value(value: string[]) {
    this._value = value
  }

  get open(): boolean {
    return this._open
  }

  set open(open: boolean) {
    this._open = open
  }

  get expand(): boolean {
    return this._expand
  }

  set expand(value: boolean) {
    this._expand = value
  }

  get search(): string {
    return this._search
  }

  set search(value: string) {
    this._search = value
  }

  get needTranslate(): boolean {
    return this.type === 'colors' || this.type === 'categories'
  }

  apply() {
    this._open = false
    this._expand = false
    this._search = ''
  }

  clear() {
    this._value = []
    this._open = false
    this._expand = false
    this._search = ''
  }

  reset(value: string[] | undefined) {
    this._value = value ?? []
    this._open = false
    this._expand = false
    this._search = ''
  }

  trigger() {
    if (this._trigger) this._trigger()
  }
}
